import React from 'react'

import { Switch } from '@app/components/util'
import {
  AbnormalPriceDetectionDrawer,
  PriceRestorationDrawer,
  PriceTranslationDrawer,
  PromoPriceTransitionDrawer,
  SuperAbnormalPriceDetectionDrawer
} from '@app/drawers'

import type { CheckingPricesCompetitorsDrawerRendererProps } from './types'

const { Case } = Switch

export const CheckingPricesCompetitorsDrawerRenderer: React.FC<CheckingPricesCompetitorsDrawerRendererProps> = ({
  open,
  selectedId,
  onClose
}) => (
  <Switch>
    <Case condition={ selectedId === 'priceTranslationIsEnabled' }>
      <PriceTranslationDrawer
        open={ open }
        onClose={ onClose }
      />
    </Case>
    <Case condition={ selectedId === 'priceRestorationIsEnabled' }>
      <PriceRestorationDrawer
        open={ open }
        onClose={ onClose }
      />
    </Case>
    <Case condition={ selectedId === 'abnormalPriceDetectionIsEnabled' }>
      <AbnormalPriceDetectionDrawer
        open={ open }
        onClose={ onClose }
      />
    </Case>
    <Case condition={ selectedId === 'promoPriceTransitionIsEnabled' }>
      <PromoPriceTransitionDrawer
        open={ open }
        onClose={ onClose }
      />
    </Case>
    <Case condition={ selectedId === 'superAbnormalPriceDetectionIsEnabled' }>
      <SuperAbnormalPriceDetectionDrawer
        open={ open }
        onClose={ onClose }
      />
    </Case>
  </Switch>
)
